package com.sweetlime.bingeamigo.di

import org.koin.core.context.startKoin

fun initKoin() {
    startKoin {
        modules(appModule, webHttpModule)
    }
}
